import { getIsApiPending, getAccessToken, getPaymentsForm, getStkData,  getStatusApiCallStatus } from '../../../selectors/motorPrivateRW/payments';
import { getPremiumCalculationUg, getSelectedCover } from '../../../selectors/motorPrivateRW/quote';
import { setExpiredAuth } from '../../../actions/motorPrivateRW/quote';
import {
    apiTransitionStkPush,
    apiTransitionPaymentsStatus,
    triggerPaymentsStkPushSuccess,
    triggerPaymentsStkPushFailure,
    checkPaymentsStatusSuccess,
    checkPaymentsStatus
} from '../../../actions/motorPrivateRW/payments';
import axios from 'axios';
import { getIsApiPaymentStatusPending } from '../../../selectors/motorPrivateRW/payments';


const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
}

let intervalId = null;
export const paymentsStkService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {

        if (!getIsApiPending(state)) {
            store.dispatch(apiTransitionStkPush.pending());
            try {
                const resp = await triggerStkPush(state);
                store.dispatch(triggerPaymentsStkPushSuccess(resp.data));
                store.dispatch(apiTransitionStkPush.success());
                intervalId = setInterval(
                    
                    () => {
                        store.dispatch(checkPaymentsStatus());
                        if (getStatusApiCallStatus(state) === 'success') {
                            clearIntervalId(intervalId);
                        }
                    },5000);
                setTimeout(() => {
                    if (intervalId) {
                        clearIntervalId(intervalId);
                        store.dispatch(apiTransitionPaymentsStatus.failure());
                        return;
                    }
                }, 300000);
            } catch (e) {
                store.dispatch(apiTransitionStkPush.failure());
                //store.dispatch(triggerPaymentsStkPushFailure(e.response));
                clearIntervalId(intervalId);
                return e;  
            }
        }
    })();
    return result;
};

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `+${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const stkPushPayload = (state) => {
    const paymentsData = getPaymentsForm(state);
    const premium = getPremiumCalculationUg(state);
    const requestId = getCurrentTimestamp();
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '250');
    const payload = {
        msisdn: msisdn,
        amount: premium.value?.data?.batchPayments[0].amount,
        trxRef: requestId,
    };
    return {
        ...payload,
    };
};

const triggerStkPush = async (state) => {

    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/payments/stk';
        return await axios.post(url, stkPushPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
         if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
             store.dispatch(setExpiredAuth(true));
         }
        store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {} ));
        throw e;
    }
};


export const paymentsStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {

         if (getStatusApiCallStatus(state) === 'success') {
             clearIntervalId(intervalId);
             return;
         }
        // if (!getIsApiPaymentStatusPending(state)) {
            store.dispatch(apiTransitionPaymentsStatus.pending());
            try {
                const resp = await triggerStkStatusCheck(state);
                if(resp.data && resp.data.data[0].status === 'success'){
                    clearIntervalId(intervalId)
                    intervalId = null;
                    store.dispatch(checkPaymentsStatusSuccess(resp.data));
                    store.dispatch(apiTransitionPaymentsStatus.success());
                    return;
                }
                
            } catch (e) {
                 if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                     store.dispatch(setExpiredAuth(true));
                 }
                //store.dispatch(apiTransitionPaymentsStatus.failure());
                console.error(e.response);
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        // }
    })();
    return result;
};

export const checkSecondTime = async (store, next, action) => {
    const intervalDuration = 3000; // Interval duration set to 3 seconds
    const timeoutDuration = 300000; // Total retry duration of 3 minutes
    let intervalId;
    let startTime = Date.now();

    const retryCheck = async () => {
        try {
            const resp = await triggerStkStatusCheck(state);
            if (resp.data && resp.data.data[0].status === 'success') {
                clearInterval(intervalId); // Stop the interval when success is received
                intervalId = null;
                store.dispatch(checkPaymentsStatusSuccess(resp.data));
                store.dispatch(apiTransitionPaymentsStatus.success());
                return;
            }
        } catch (e) {
            if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                store.dispatch(setExpiredAuth(true));
                clearInterval(intervalId); // Stop retrying if unauthorized
                return e;
            }
            console.error(e.response);
            console.error(e);
        }

        // Stop retrying after 3 minutes (180,000 milliseconds)
        if (Date.now() - startTime >= timeoutDuration) {
            clearInterval(intervalId); // Stop the interval after timeout
            console.log("Retry time expired after 3 minutes.");
            return;
        }
    };

    intervalId = setInterval(retryCheck, intervalDuration); // Run the check every 3 seconds
};


const stkStatusPayload = (state) => {
    const stkData = getStkData(state);
    const payload = {
        trxRef: stkData.momoResponse.data.trxRef || null,
    };
    return {
        ...payload,
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/payments/stk/status';
        return await axios.post(url, stkStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
